<div class="theme-container">
    <div class="breadcrumb">
        <div class="breadcrumb__left header-h1 p-26">
            <h1 class="header-h1 fw-700 color__primary">Monitoring</h1>
        </div>
    </div>
    <div class="theme-container-inner">
        <div class="CommonContainerCard border__radius8 mon-cotainer">
            <div class="CommonFiltersPanel m-action-panel">
                <div class="ResetFiltersTxt body-b fw-700 df-c justify-content-start col-gap-8">
                    <span class="fleet-section-title body-b">Filter(s)</span>
                </div>
                <div class="m-top">
                    <span class="fleet-section-title body-b">From: </span>
                </div>
                <div style="max-width: 300px; max-height: 500px;" class="overlay-monitoring">
                    <snl-date-picker-dropdown datePickerType="date-time" title="Date and time" class="date-picker datePickerStart"
                        [isMilitaryTime]="true" (timeChange)="onTimeChange($event)"
                        (selectedDate)=selectedFromDate($event) [max]="todayDate">
                    </snl-date-picker-dropdown>
                </div>
                <div class="m-top">
                    <span class="fleet-section-title body-b">To: </span>
                </div>
                <div style="max-width: 300px;">
                    <snl-date-picker-dropdown datePickerType="date-time" title="Date and time" class="date-picker datePickerEnd"
                        [isMilitaryTime]="true" (timeChange)="onTimeChange($event)"
                        (selectedDate)=selectedToDate($event) [max]="todayDate">
                    </snl-date-picker-dropdown>
                </div>
                <snl-dropdown [label]="'Function App'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
                    [options]="dropdownOptions" [showAll]="true" [isInsideModal]="false"
                    (selectedValues)="selectedValues($event)">
                </snl-dropdown>

                <snl-button type="primary" size="large" (click)="getLog()">
                    Filter
                </snl-button>
            </div>

            <div class="log-container body-b" [ngClass]="filterLogs?.data.getLog.data.length ? 'showFilterHeight' : ''">
                <div *ngIf="noFilter">
                    <p>Apply for Filter to see the log</p>
                </div>
                <div *ngIf="filterLogs?.data.getLog.data.length">
                    <div *ngFor='let log of filterLogs.data.getLog.data'>
                        <p> {{ log.timestamp }} {{ log.message }} </p>
                    </div>
                </div>
                <div *ngIf="!noFilter && !filterLogs?.data.getLog.data.length">
                    <p>No logs</p>
                </div>
            </div>
        </div>
    </div>
    <div class="m-downloadBtn">
        <div class="dnl-btn">
            <snl-button type="primary" size="large" (click)="downloadTxtFile()">
                Download
            </snl-button>
        </div>
    </div>
</div>